import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildLegalHead } from "@/lib/legalSeo";

export const Route = createFileRoute("/wizard-consumer-terms")({
  head: () => buildLegalHead("/wizard-consumer-terms"),
  component: lazyRouteComponent(() => import("@/pages/WizardConsumerTerms")),
});
